import { PureComponent } from "react";
import NewListContainer from "Containers/SmartList/NewList";
import ExistingListContainer from "Containers/SmartList/ExistingList";
import EditListContainer from "Containers/SmartList/EditList";
import SelectList from "Containers/SmartList/SelectList";
import PermissionsContainer from "Containers/SmartList/Permissions";
import DeleteListContainer from "Containers/SmartList/DeleteList";
import ExistingIndividualListContainer from "Containers/SmartList/ExistingIndividualList";

class SmartList extends PureComponent {
  static New = NewListContainer;
  static Edit = EditListContainer;
  static Select = SelectList;
  static Add = ExistingListContainer;
  static Permissions = PermissionsContainer;
  static Delete = DeleteListContainer;
  static ExistingIndividualList = ExistingIndividualListContainer;
}

export default SmartList;
try {
    // @ts-ignore
    SmartList.displayName = "SmartList";
    // @ts-ignore
    SmartList.__docgenInfo = { "description": "", "displayName": "SmartList", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/SmartList/SmartList.tsx#SmartList"] = { docgenInfo: SmartList.__docgenInfo, name: "SmartList", path: "src/shared/components/SmartList/SmartList.tsx#SmartList" };
}
catch (__react_docgen_typescript_loader_error) { }